import { render, staticRenderFns } from "./label.vue?vue&type=template&id=182b0e82&scoped=true"
import script from "./label.vue?vue&type=script&lang=js"
export * from "./label.vue?vue&type=script&lang=js"
import style0 from "./label.vue?vue&type=style&index=0&id=182b0e82&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182b0e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('182b0e82')) {
      api.createRecord('182b0e82', component.options)
    } else {
      api.reload('182b0e82', component.options)
    }
    module.hot.accept("./label.vue?vue&type=template&id=182b0e82&scoped=true", function () {
      api.rerender('182b0e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/examination/label.vue"
export default component.exports